@if (!isAuthenticated) {
  <mat-nav-list class="d-flex flex-column flex-grow-1" (click)="sidenavRef.toggle()">
    @if (headerLoggedOutSettings?.length) {
      <div>
        @for (item of headerLoggedOutSettings; track item) {
          @if (headerLoggedOutSettings && currentNavList === NavLists.claims) {
            @if (programInfoLinks?.length) {
              <a mat-list-item class="link-primary-dark" (click)="backClick($event);">
                <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
              </a>
              @for (childItem of programInfoLinks; track childItem) {
                <a
                  mat-list-item
                  [gtmClick]="childItem.Caption"
                  gtmLinkURL="Header Claims Link"
                  (click)="this.programLinkClick(childItem)">
                  {{ childItem.Caption }}
                  <mat-divider></mat-divider>
                </a>
              }
            }
          }
          @if (item.LinkUrl.startsWith('http')) {
            <a
              mat-list-item
              [href]="item.LinkUrl"
              [target]="item.OpenNewTab ? '_blank' : '_self'"
              routerLinkActive="active"
              [gtmClick]="item.Caption"
              gtmLinkURL="Header Link">
              {{ item.Caption }}
            </a>
            <mat-divider></mat-divider>
          } @else {
            @if (item.LinkUrl === '^program_information' && currentNavList !== NavLists.claims) {
              <a
                mat-list-item
                routerLinkActive="active"
                href="javascript:void(0);"
                (click)="showChildren($event)"
                [gtmClick]="item.Caption"
                gtmLinkURL="Header Link">
                {{ item.Caption }}
              </a>
            }
            @if (item.LinkUrl !== '^program_information' && currentNavList !== NavLists.claims) {
              <a
                mat-list-item
                [routerLink]="item.LinkUrl"
                routerLinkActive="active"
                gtmClick="Profile"
                gtmLinkURL="Header Link">
                {{ item.Caption }}
              </a>
            }
          }
        }
        @if (chooseLanguage) {
          <mat-divider></mat-divider>
          <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);"
          (click)="toggleLanguage()">{{chooseLanguage}}</a>
        }
      </div>
    } @else {
      @if (chooseLanguage) {
        <a [title]="chooseLanguageTitle" class="language-toggle language-noheaders" href="javascript:void(0);"
        (click)="toggleLanguage()">{{chooseLanguage}}</a>
      }
    }
  </mat-nav-list>
}
